import { Vue, Component } from "vue-property-decorator";
import ConfirmDlg from "@/components/popup/confirm-dialog/ConfirmDlg.vue";
import { toTranslationKey } from "@/utils/stringFormat";

@Component({
  components: {
    ConfirmDlg
  }
})
export default class DepartureAndTransferView extends Vue {

  selectedResident = null;
  selectedResidentOption = null;
  selectedFacility = null;
  errorMessage = ''
  isLoading = false
  options = [
    {text: this.$t('Settings.DepartureAndTransfer.ResidentDeparture'), value: 'Resident Departure'},
    {text: this.$t('Settings.DepartureAndTransfer.ResidentTransfer'), value: 'Resident Transfer'}
  ]

  get getFacilitiesForOrg() {
    return this.$store.state.userModule.facilitiesForOrg
  }

  get residents() {
    return this.$store.state.residentModule.residentsShortData;
  }
  mounted() {
    this.$store.dispatch("getFacilitiesForOrg");
  }

  completeAction(): void{
    if(this.selectedResidentOption == 'Resident Transfer'){
      this.transferResident(this.selectedFacility);
    }else if(this.selectedResidentOption == 'Resident Departure'){
      this.departResident();
    }
  }

  convertToTranslationKey(text: string){
    return toTranslationKey(text)
  }

  departResident(): void {
    this.isLoading = true
    this.$store.dispatch("residentDeparture", this.selectedResident.id).then(()=> {
      this.$toast.open({
        message: this.$i18n.messages[this.$i18n.locale]['Settings.DepartureAndTransfer.SuccessfulDeparture'] as string,
        type: "success"
      });
    }).catch((error) => {
      this.$toast.open({
        message: error.message as string,
        type: "success"
      });
    }).finally(() => this.isLoading = false)
  }
  
  transferResident(newFacilityId): void {
    (this.$refs.confirmationModal as any)
      .open(null,
        this.$i18n.messages[this.$i18n.locale]['Settings.DepartureAndTransfer.TransferResidentQuestionText'],false)
      .then(response => {
        if (response && response.agree) {
          this.isLoading = true
          this.$store.dispatch("residentTransfer", {residentId: this.selectedResident.id, facilityId: newFacilityId })
          .then(result=>{
            if(result.status == 200){
              this.errorMessage = '';
              this.$toast.open({
                message: this.$i18n.messages[this.$i18n.locale]['Settings.DepartureAndTransfer.SuccessfulTransfer'] as string,
                type: "success"
              });
            }else{
              this.errorMessage = result.code
            }
          })
          .finally(()=> this.isLoading = false);
        }
      });
  }
}
